import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { postApiCall, } from "./tokenService";
import { InstantMessageListItems } from "ui/Scripts/source/models/instantMessage/instantMessageListItems";

export const goToInstantMessagePage = () => {
    //InstantMessages do not exist in old site
    //return navigateTo("InstantMessage");
};

// #region InstantMessagePage
export const getInstantMessageListItems = (companyId: string, channelId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<InstantMessageListItems> => {
    return postApiCall<InstantMessageListItems>("api/instantmessage/list", InstantMessageListItems, JSON.stringify({
        companyId,
        channelId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const saveInstantMessage = (obj: any): Promise<SaveSuccess> => {
    return postApiCall<SaveSuccess>("api/instantmessage/save", SaveSuccess, JSON.stringify(obj));
};

export const removeInstantMessage = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessage/remove?id=" + id, ApiSuccess);
};

export const restoreInstantMessage = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessage/restore?id=" + id, ApiSuccess);
};

export const sendInstantMessageReadReceipts = (ids: string[]): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessage/sendreadreceipts", ApiSuccess, JSON.stringify(ids));
};
// #endregion InstantMessagePage